export const AI_WIZARD_SUBMIT_CV = "AI_WIZARD_SUBMIT_CV";